import { ResourceFilters } from '../../types/ResourceFilters';
import { useGetReport } from '../base/useGetReport';

export const useGetResourcesReport = (
    filters: ResourceFilters,
    sorting: { direction: 'asc' | 'desc'; field: string }
) => {
    const { downloadReport, downloadingReport } = useGetReport<ResourceFilters>('resources', filters, sorting);

    return {
        downloadReport,
        downloadingReport
    };
};
